export const buildForm = location => ({
  ...location,
  turf_id: location.turf?.id,
})
